import React, { Component } from 'react';
import RouteTitle from '../../../shared/route-title/RouteTitle';
import PropTypes from 'prop-types';
import './WorkOrderCreated.css';
import checkCirclePng from '../../../../images/check-circle.png';
import { connect } from 'react-redux';
import ConfirmationPanel from '../../../shared/confirmation/ConfirmationPanel';
import { getCurrentWorkOrder } from '../../../../selectors/admin/work-orders/work-orders';
import { goToTasks } from '../../../../actions/admin/work-orders/creation/creation';

class WorkOrderCreated extends Component {
  static propTypes = {
    newWorkOrder: PropTypes.object,
    onGoToTasks: PropTypes.func,
  };

  handleAddTask = (event) => {
    event.preventDefault();
    this.props.onGoToTasks();
  };

  render() {
    return (
      <div className="work-order-created">
        <RouteTitle
          titles={['WORK ORDERS', 'WO #' + this.props.newWorkOrder.number]}
        />

        <div className="full-title">
          Work Order #{this.props.newWorkOrder.number}
        </div>

        <div className="content-container">
          <ConfirmationPanel
            image={checkCirclePng}
            firstLine="Work Order Created"
            lines={['Add one or more Task for this Work Order.']}
            buttons={[
              <input
                type="button"
                className="btn button button-orange"
                value="Add Task"
                onClick={this.handleAddTask}
              />,
            ]}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      newWorkOrder: getCurrentWorkOrder(state),
    };
  },
  (dispatch) => {
    return {
      onGoToTasks: () => {
        dispatch(goToTasks());
      },
    };
  }
)(WorkOrderCreated);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/WorkOrderCreated.js